export default __webpack_public_path__ + "static/toolbar-create-new-action-dark-mode-da5ec540eca18f7773966419fda83d56.mp4";